import { createStyles, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';

const FsBody = withStyles(() =>
  createStyles({
    root: {},
  })
)((props: TypographyAllProps) => (
  <Typography variant="body1" component="p" {...props} />
));

export default FsBody;
